export const isNumber = (s: unknown): boolean => {
  return (
    // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    // ...and ensure strings of whitespace fail
    !isNaN(s as number) && !isNaN(parseFloat(s as string))
  );
};
